/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, bool, shape,
    string, number,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Edit from '@material-ui/icons/Edit';
import Form from '../../../../common/Form';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import configENV from '../../../../config';
import { getUpdatedUserEmail } from '../../../../state/ducks/Common/Common-Selectors';
import { getIsAuthenticatedStatus } from '../../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';

const { COULD_UPDATE_EMAIL_PREFERENCE_AFTER, PERSIST_KEY } = configENV;
const styles = ({
    messageWidth: {
        width: '100%',
        maxWidth: 300,
    },
    verticalAlignMiddle: {
        verticalAlign: 'middle',
    },
});
class DesktopAccountEmailPreference extends Form {
    // eslint-disable-next-line camelcase
    componentDidMount = () => {
        const { fetchEmailPreference, isAuthenticated } = this.props;
        if (isAuthenticated) fetchEmailPreference(false); // set option to false to skip error modal
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const { data } = this.state;
        data.optInOut = !props.isSubscribed;
        this.setState({ data });
    };

    handleGotoURL = (url) => {
        const { history: { push } } = this.props;
        push(url);
    };

    signUpCopyTemplate = (isSubscribed, isUpdateAvailable) => {
        const { classes } = this.props;
        const subscribeInfo = (
            <>
                <p className="margin-bottom">
                    {isSubscribed
                        ? 'You are currently signed up to receive our emails!'
                        : 'Sign up to receive emails about our special offers!'}{' '}
                </p>
            </>
        );

        const updateUnavailable = (
            <>
                {isSubscribed ? (
                    subscribeInfo
                ) : (
                    <p>
                        You have currently opted-out, you will no longer receive
                        these communications. However, you will continue to
                        receive email communications about the status of your
                        order.
                    </p>
                )}
            </>
        );

        return (
            <>
                <div className={`padding-top padding-bottom-2x bold ${classes.messageWidth}`}>
                    {isUpdateAvailable ? subscribeInfo : updateUnavailable}
                </div>
            </>
        );
    };

    render() {
        const {
            classes,
            isSubscribed,
            email,
            timestamp,
        } = this.props;
        // Email update data
        // Preference edit time
        const currentTime = new Date().getTime();
        const elapsedTime = (currentTime - timestamp) / 1000;
        const isUpdateAvailable = elapsedTime > COULD_UPDATE_EMAIL_PREFERENCE_AFTER;
        return (
            <>
                <div className="padding">
                    {this.signUpCopyTemplate(isSubscribed, isUpdateAvailable)}
                    <div
                        className="padding-top padding-bottom-2x"
                    >
                        <span> Email: </span>
                        <span className="bold">{email}</span>

                    </div>
                    <div className="blue-color align-right">
                        <span className="link-button" role="presentation" onClick={() => this.handleGotoURL('/account/email-preference')}>
                            <Edit className={`link-icon ${classes.verticalAlignMiddle}`} />
                            <span className="link-label">Edit</span>
                        </span>
                    </div>
                </div>

            </>
        );
    }
}

DesktopAccountEmailPreference.defaultProps = {
    isSubscribed: false,
    email: '',
    timestamp: 0,
    isFetchingModal: true,
    history: {},
    isAuthenticated: false,
};

DesktopAccountEmailPreference.propTypes = {
    classes: object.isRequired,
    history: object,
    isFetchingModal: bool,
    isSubscribed: bool,
    email: string,
    isAuthenticated: bool,
    timestamp: number,
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }).isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isFetchingModal,
        toggleState: newState.toggleState,
        isSubscribed: newState.isSubscribed,
        email: getUpdatedUserEmail(state),
        isAuthenticated: getIsAuthenticatedStatus(state),
        timestamp: newState.timestamp,
        errorMessage: newState.error ? newState.error.message : '',
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchEmailPreference: (errorModal) => dispatch(EventDispatcher.fetchEmailPreference(errorModal)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(DesktopAccountEmailPreference)));
